export const siteInfo = {
  name: "黑料网爆",
  slogan: "全网热点爆料聚合 · 实时吃瓜雷达",
  intro:
    "黑料网爆是一个把全网热点集中到一屏的娱乐资讯聚合站。实时爆料、晚间热搜、刚刚发生的新鲜事在这里按时间与热度排好队，打开就知道全网正在聊什么。",
  email: "hi@heiliaowangbao.example.com",
  cooperation: "bd@heiliaowangbao.example.com",
  hours: "每日 09:00 - 次日 02:00 持续更新",
  icp: "",
};

export const hotTickerItems = [
  "今晚热搜榜更新：综艺首播舞台片段讨论量破百万",
  "刚刚发生：影视新剧杀青路透刷屏，服化道细节被放大研究",
  "实时跟进：音乐节首批阵容官宣，评论区一片沸腾",
  "晚间热搜：品牌秋冬大片释出，取景地成新打卡点",
  "全网热议：海外剧集定档，字幕组集体连夜开工",
  "蹲点必看：周末综艺新一期嘉宾名单引起猜测",
  "热度飙升：热播剧 OST 上线两小时播放破百万",
];

export const eveningHot = [
  { rank: 1, title: "综艺《星光练习生》第三季首播舞台片段流出，网友吵翻", heat: "986.4万", tag: "沸" },
  { rank: 2, title: "古装剧《长安雾》杀青路透曝光，服化道细节获一致好评", heat: "812.7万", tag: "热" },
  { rank: 3, title: "某音乐节官宣首批阵容，票务平台一度拥堵", heat: "743.1万", tag: "热" },
  { rank: 4, title: "国民品牌官宣全新代言阵容，海报风格引两极讨论", heat: "688.9万", tag: "新" },
  { rank: 5, title: "夏日限定话题冲上热搜，网友晒出同款打卡地", heat: "611.3万", tag: "新" },
  { rank: 6, title: "悬疑电影《雾港》首支预告发布，镜头语言获好评", heat: "560.2万", tag: "" },
  { rank: 7, title: "独立乐队巡演城市名单更新，二手平台票价波动", heat: "498.6万", tag: "" },
  { rank: 8, title: "老牌综艺宣布回归，主持人阵容微调引发讨论", heat: "455.0万", tag: "" },
];

export const hotKeywords = [
  "星光练习生首播",
  "长安雾杀青",
  "音乐节阵容",
  "秋冬大片取景地",
  "霓虹街角定档",
  "周末不打烊嘉宾",
  "雾港预告",
  "巡演加场",
  "OST破百万",
  "夏日限定打卡",
];

export const testimonials = [
  {
    name: "林一川",
    role: "追综十年的老观众",
    text: "最舒服的地方是它把「刚刚发生」单独拎出来了。以前要刷好几个平台才能拼出事情全貌，现在打开首页扫一眼就知道今天在吵什么。",
    avatar: "https://readdy.ai/api/search-image?query=warm%20minimal%20abstract%20portrait%20oft%20a%20young%20asian%20man%20with%20soft%20amber%20studio%20lighting%20plain%20cream%20background%20editorial%20style%20high%20detail&width=200&height=200&seq=hlwb-testi-01&orientation=squarish",
  },
  {
    name: "顾念",
    role: "影视剧重度爱好者",
    text: "晚间热搜榜按热度排好序，还标了沸、热、新，晚上刷一遍基本不会漏。相关推荐也挺准，经常一篇文章看进去半小时。",
    avatar: "https://readdy.ai/api/search-image?query=warm%20minimal%20abstract%20portrait%20oft%20a%20young%20asian%20woman%20with%20soft%20amber%20studio%20lighting%20plain%20cream%20background%20editorial%20style%20high%20detail&width=200&height=200&seq=hlwb-testi-02&orientation=squarish",
  },
  {
    name: "周牧",
    role: "音乐现场常客",
    text: "音乐节和巡演的信息更新很快，官宣当天就能看到整理好的阵容和城市名单，省了我自己去翻评论区的时间。",
    avatar: "https://readdy.ai/api/search-image?query=warm%20minimal%20abstract%20portrait%20of%20an%20asian%20man%20with%20short%20hair%20soft%20amber%20studio%20lighting%20plain%20cream%20background%20editorial%20style%20high%20detail&width=200&height=200&seq=hlwb-testi-03&orientation=squarish",
  },
];